// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__u0a8b","errorLogs":"EditorFooter_errorLogs__2LVmW"};